import { NgModule, } from '@angular/core';
import { Routes, RouterModule, InitialNavigation } from '@angular/router';
import { ProductComponent } from './pages/product/product.component';
import { UniPageComponent } from './pages/uni-page/uni-page.component';
import { CatalogComponent } from './pages/catalog/catalog.component';
import { HomeComponent } from './pages/home/home.component';
import { SearchComponent } from './pages/search/search.component';
import { ContactsComponent } from './pages/contacts/contacts.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';


const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'uni-page/:sysname', component: UniPageComponent },
  { path: 'contacts', component: ContactsComponent },
  { path: 'product/:id', component: ProductComponent },
  { path: 'catalog/:id', component: CatalogComponent },
  { path: 'catalog/:id/:lastId', component: CatalogComponent },
  { path: 'search', component: SearchComponent },
  { path: '**', component: PageNotFoundComponent },
  { path: '404', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
